import React, { useState } from 'react';
import Input from '../Authorization/input.js';
import { Modal, Button } from 'react-bootstrap';
import Privacy from '../../pages/Privacy';
import Consent from '../../pages/UserConsent';
import EthnicityInput from './EthnicityInput.js';
import GenderInput from './GenderInput.js';

const SignUpForm = ({ formData, handleChange, showPassword, handleShowPassword, setAgeError }) => {

    const [show, setShow] = useState(false);
    const [consent, setConsent] = useState(false);
    const [passwordError, setPasswordError] = useState("");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const closeConsent = () => setConsent(false);
    const showConsent = () => setConsent(true);

    const handlePasswordChange = (e) => {
        handleChange(e);
        const password = e.target.value;

        // Validate password
        const passwordRegex = /^.{4,}$/; // Password must be at least 4 characters long
        if (!passwordRegex.test(password)) {
            setPasswordError("Password must be at least 4 characters long.");
        } else {
            setPasswordError("");
        }
    };

    // Add this function
    const handleDateOfBirthChange = (e) => {
        handleChange(e);
        const dob = new Date(e.target.value);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        const dayDiff = today.getDate() - dob.getDate();
        
        // Check if user is actually 18+ (accounting for month/day)
        const isOldEnough = age > 18 || (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)));
        
        if (!isOldEnough) {
            setAgeError("You must be at least 18 years old to sign up.");
        } else {
            setAgeError("");
        }
    };

    return (
        <>
            <Input
                id="username-input"
                name="username"
                label="Username"
                handleChange={handleChange}
                autoFocus
                type="text"
                autoComplete="username"
                required
            />
            <Input
                id="email-input"
                name="email"
                label="Email Address"
                handleChange={handleChange}
                type="email"
                autoComplete="email"
                required
            />
            <div className="form-group">
                <GenderInput value={formData.gender} onChange={handleChange} />
            </div>
            <Input
                id="dob-input"
                name="dateOfBirth"
                label="Date of Birth"
                handleChange={handleDateOfBirthChange} // Use the new handler
                type="date"
                max={new Date().toISOString().split("T")[0]}
                required
            />
            <div className="form-group">
                <EthnicityInput value={formData.ethnicity} onChange={handleChange} />
            </div>
            <div className="form-group">
                <label htmlFor="community-input"><strong>Part of GGC Community</strong></label>
                <select
                    id="community-input"
                    name="community"
                    value={formData.community}
                    onChange={handleChange}
                    className="form-control"
                    required
                >
                    <option value="" className="placeholder-option">Select Yes or No</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </div>
            {passwordError && <div className="alert alert-danger mt-3">{passwordError}</div>}
            <Input
                id="password-input"
                name="password"
                label="Password"
                handleChange={handlePasswordChange}
                type={showPassword ? "text" : "password"}
                handleShowPassword={handleShowPassword}
                required
            />
            <Input
                id="confirm-password-input"
                name="confirmPassword"
                label="Repeat Password"
                handleChange={handleChange}
                type={showPassword ? "text" : "password"}
                handleShowPassword={handleShowPassword}
                required
            />

<div className="form-group form-check">
  <input
    type="checkbox"
    className="form-check-input"
    id="agreementsAccepted"
    name="agreementsAccepted"
    checked={formData.agreementsAccepted || false}
    onChange={handleChange}
    required
  />
  <label className="form-check-label" htmlFor="agreementsAccepted" style={{ lineHeight: '1.4', paddingLeft: '0.5rem' }}>
    I have read and agree to the{' '}
    <button
      type="button"
      className="btn btn-link p-0 align-baseline"
      onClick={(e) => { e.stopPropagation(); handleShow(); }}
      aria-haspopup="dialog"
    >
      User Privacy Agreement
    </button>
    {' '}and the{' '}
    <button
      type="button"
      className="btn btn-link p-0 align-baseline"
      onClick={(e) => { e.stopPropagation(); showConsent(); }}
      aria-haspopup="dialog"
    >
      User Consent Agreement
    </button>
    .
  </label>
</div>

            {/* User privacy popup */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Privacy Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Privacy />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* User consent Popup */}
            <Modal show={consent} onHide={closeConsent} centered>
                <Modal.Header closeButton>
                    <Modal.Title>User Consent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Consent />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeConsent}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};
export default SignUpForm;